<template>

	<div id="loginWrapper" v-if="isLoaded">

		<div class="topBar"></div>
		<div class="logo"></div>

		<div class="loginContainer" :class="{ isError: isError }">

            <h1>{{ labels['RECOVER-TITLE-SET_NEW_PASSWORD']}}</h1></h1>

			<!-- no token found or token invalid -->
			<template v-if="!tokenOK">

				<alert type="warning">{{ labels['RECOVER-MSG-WRONG_TOKEN'] }}</alert>

			</template>

			<!-- token ok but pass change problem -->
			<template v-else-if="tokenOK && passChangeSuccess==false">

				<template v-if="isError">
					<p class="errorMsg"> {{ errorMsg }} </p>
	            </template>

				<form role="form" @submit.prevent="submitForm">

					<div class="field">
						<div class="control has-icon">
							<input type="password" class="input is-medium" :placeholder="labels['RECOVER-PLACEHOLDER-PASSWORD']" v-model="pass1" autocorrect="off" required>
							<i class="fa fa-lock"></i>
						</div>
					</div>

					<div class="field">
						<div class="control has-icon">
							<input type="password" class="input is-medium" :placeholder="labels['RECOVER-PLACEHOLDER-PASSWORD_REPEAT']" v-model="pass2" autocorrect="off" required>
							<i class="fa fa-lock"></i>
						</div>
					</div>

					<div class="field">
						<div class="control">
							<button type="submit" class="button is-normal is-dark is-pulled-right" :class="{ 'is-loading': isLoading }">Speichern</button>
						</div>
					</div>

				</form>

			</template>

			<!-- everything is fine -->
			<template v-else-if="tokenOK && passChangeSuccess">

				<alert type="success"><span v-html="successMsg"></span></alert>

			</template>

        </div>


    </div>

</template>


<script>
import router from '../router'


export default {

	data() {

		return {
			labels: null,
			isLoaded: false,
			isError: false,
			errorMsg: false,
			successMsg: false,
			passwordResetMsg: false,
            isLoading: false,
			token: null,
			tokenOK: false,
			passChangeSuccess: false,
			pass1: null,
			pass2: null
		}
	},

	created() {

		if(this.$route.query.token && this.$route.query.token.length == 32) {

			this.token = this.$route.query.token;
			this.tokenOK = true;

		} else {

			this.tokenOK = false;
			this.isError = true;
			this.errorMsg = '';

		}

		this.fetchLabels();

	},

	mounted() {


	},

    computed: {

		matchPassword: function () {
			return this.pass1 === this.pass2
		}

    },

	methods: {


		submitForm() {

			this.isError = false;
			this.isLoading = true;
			this.errorMsg = "";

			if(false == this.matchPassword) {

				this.isLoading = false;
				this.isError = true;
				this.errorMsg = this.labels['RECOVER-MSG-PASSWORDS_NOT_MATCHING'];

			} else if(this.pass1 == null) {

				this.isLoading = false;
				this.isError = true;
				this.errorMsg = this.labels['RECOVER-MSG-PASSWORD_EMPTY'];

			} else if(this.pass1.length < 1) {

				this.isLoading = false;
				this.isError = true;
				this.errorMsg = this.labels['RECOVER-MSG-PASSWORD_TOO_SHORT'];

			} else {

				var that = this;
				const apiURL = this.$config.api + 'user/saveNewPassword?newPassword='+this.pass1+'&token='+this.token;

				this.axios.post(apiURL)
		            .then((response) => {

						that.isLoading = false;
						this.passChangeSuccess = true;
						that.successMsg = this.labels['RECOVER-MSG-PASSWORD_CHANGE_SUCCESS'];

						// redirect to login page
						setTimeout(function() {
							router.replace('/login')
						}, 5000)

		            }).catch((err) => {
		                that.isLoading = false;
		               	that.isError = true;
		                that.errorMsg = err.response.data.title;
		            })

			}
		},

		fetchLabels() {

			var self = this;

			this.axios.get(this.$config.api + 'label/keyValueList?language=de&app=cms')
	            .then((response) => {

					self.labels = response.data;
					self.isLoaded = true;

	            }).catch((err) => {

	            });

		}
	}

}
</script>



<style scoped>
#loginWrapper {
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	width: 100%;
	height: 100%;
	width: 100vw;
	height: 100vh;
	background: transparent url('/static/img/herba-login-bg.jpg') no-repeat 50% 50% !important;
	background-size: cover !important;
}

#loginWrapper .logo {
	position: absolute;
	z-index: 999;
	width: 150px;
	height: 50px;
	left: 0; right: 0;
	margin: 20px 0 0 20px;
	background: transparent url('/static/img/hc-logo.png') no-repeat 0 0 !important;
	background-size: contain !important;
}
#loginWrapper .topBar {
	position: absolute;
	z-index: 999;
	top: 0;
	left: 0;
	right: 0;
	width: auto;
	height: 8px;
	/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#cade74+0,87cbf0+100 */
	background: #cade74; /* Old browsers */
	background: -moz-linear-gradient(left, #cade74 0%, #87cbf0 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(left, #cade74 0%,#87cbf0 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to right, #cade74 0%,#87cbf0 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cade74', endColorstr='#87cbf0',GradientType=1 ); /* IE6-9 */
}

#loginWrapper .loginContainer {
	background: rgba(255, 255, 255, 0.6);
	position: absolute;
	top: 50%;
	left: 50%;
	margin-right: -50%;
	transform: translate(-50%, -50%);
	min-width: 420px;
	max-width: 50vmin;
	box-shadow: 1px 1px 10px rgba(0,0,0,0.1);
	padding: 25px;
}
#loginWrapper .loginContainer .infoText {
	font-size: 1rem;
	margin: 0 0 10px 0;
}
#loginWrapper .isError {
	animation: shake .6s ease-out;
}

#loginWrapper h1 {
	/*font-size: 24px;*/
	font-size: 20px;
	text-transform: uppercase;
	margin: 0 0 10px 0;
}
#loginWrapper .errorMsg {
	color: red;
	margin: 0 0 15px 0;
	font-size: 0.85rem;
}
#loginWrapper .field {
	margin: 0 0 10px 0;
}
#loginWrapper .passForgot,
#loginWrapper .cancel {
	display: inline-block;
	margin: 6px 0 0 5px;
	cursor: pointer;
}
#loginWrapper .passForgot:hover,
#loginWrapper .cancel:hover {
	text-decoration: underline;
}

#loginWrapper .notification {
	margin-top: 15px;
	background-color: #efefef !important;
	color: #222;
}
#loginWrapper .notification.is-info .wrap-icon .fa {
	color: #222;
}
#loginWrapper .notification.is-success .wrap-icon .fa {
	color: #6cc788;
}
#loginWrapper .notification.is-warning .wrap-icon .fa {
	color: rgb(243, 156, 18);
}

#loginWrapper input:-webkit-autofill {
	-webkit-box-shadow: 0 0 0 30px white inset;
}
</style>
